import { Routes, Route } from 'react-router-dom';
import { Container, Title, Text } from '@mantine/core';
import Home from './pages/Home';
import ProductsPage from './pages/ProductsPage';
import ProductDetailPage from './pages/ProductDetailPage';
import CartPage from './pages/CartPage';
import ProfilePage from './pages/ProfilePage';
import SellersPage from './pages/SellersPage';
import PrincessDetailPage from './pages/PrincessDetailPage';
import SellerRegistrationPage from './pages/SellerRegistrationPage';
import SellerDashboardPage from './pages/seller/SellerDashboardPage';
import SellerProducts from './pages/seller/SellerProducts';
import SellerMediaPage from './pages/seller/SellerMediaPage';
import SellerAlbumsPage from './pages/seller/SellerAlbumsPage';
import AlbumDetailPage from './pages/AlbumDetailPage';
import CreateProductPage from './pages/seller/CreateProductPage';
import SubscriptionPage from './pages/SubscriptionPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import MessagesPage from './pages/MessagesPage';
import ConversationPage from './pages/ConversationPage';
import MySpecialRequestsPage from './pages/user/MySpecialRequestsPage';
import PurchasesPage from './pages/user/PurchasesPage';
import ReferralsPage from './pages/user/ReferralsPage';
import FanSubscriptionsPage from './pages/user/FanSubscriptionsPage';
import BuyerVerificationPage from './pages/user/BuyerVerificationPage';
import SellerEarningsPage from './pages/seller/SellerEarningsPage';
import FavoritesPage from './pages/FavoritesPage';
import BlockedUsersPage from './pages/BlockedUsersPage';
import NotificationsPage from './pages/NotificationsPage';
import SpecialRequestsPage from './pages/seller/SpecialRequestsPage';
import SpoilPrincessPage from './pages/SpoilPrincessPage';

// Simple 404 component
const NotFound = () => (
  <Container size="sm" py="xl">
    <Title order={1}>404 - Page Not Found</Title>
    <Text mt="md" c="dimmed">The page you're looking for doesn't exist.</Text>
  </Container>
);

function App() {
  console.log('App component rendering, PrincessDetailPage:', PrincessDetailPage);
  return (
    <Routes>
      <Route index element={<Home />} />
      <Route path="products" element={<ProductsPage />} />
      <Route path="products/:productId" element={<ProductDetailPage />} />
      <Route path="cart" element={<CartPage />} />
      <Route path="profile" element={<ProfilePage />} />
      <Route path="princesses" element={<SellersPage />} />
      <Route path="princess/:princessId" element={<PrincessDetailPage />} />
      <Route path="spoil-princess/:princessId" element={<SpoilPrincessPage />} />
      <Route path="become-princess" element={<SellerRegistrationPage />} />
      <Route path="seller" element={<SellerDashboardPage />} />
      <Route path="seller/products" element={<SellerProducts />} />
      <Route path="seller/media" element={<SellerMediaPage />} />
      <Route path="seller/albums" element={<SellerAlbumsPage />} />
      <Route path="seller/earnings" element={<SellerEarningsPage />} />
      <Route path="albums/:albumId" element={<AlbumDetailPage />} />
      <Route path="seller/create-product" element={<CreateProductPage />} />
      <Route path="subscription" element={<SubscriptionPage />} />
      <Route path="login/*" element={<LoginPage />} />
      <Route path="register/*" element={<RegisterPage />} />
      <Route path="favorites" element={<FavoritesPage />} />
      <Route path="purchases" element={<PurchasesPage />} />
      <Route path="referrals" element={<ReferralsPage />} />
      <Route path="my-subscriptions" element={<FanSubscriptionsPage />} />
      <Route path="settings/blocked" element={<BlockedUsersPage />} />
      <Route path="settings/verification" element={<BuyerVerificationPage />} />
      <Route path="notifications" element={<NotificationsPage />} />
      <Route path="messages" element={<MessagesPage />} />
      <Route path="messages/:userId" element={<ConversationPage />} />
      <Route path="my-requests" element={<MySpecialRequestsPage />} />
      <Route path="seller/special-requests" element={<SpecialRequestsPage />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default App;
